// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"c83dc2b0","514":"b8acc14f","988":"fd2a18d6","989":"a8b2c746"}[chunkId] + ".chunk.js";
};